import axios from 'axios';
import { CURRENT_API_URL } from "../../../../Utils/Constants";
import notify from "../../../../Notifications/ToastifyActions";


function RefreshKeywordService(token, asin) {
    return axios.post(`${CURRENT_API_URL}/campaign/refreshKeywordsForProduct`, {
        asin: asin,
    }, {
        headers: {
            'Authorization': token,
        },
    }).then(() => {
        notify.NotifySuccess("Keywords refreshed successfully!");
        return true;
    }).catch(() => {
        notify.NotifyError("An error occurred while refreshing keywords, please try again.");
        return false;
    })
}

export default RefreshKeywordService;